var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { attrs: { id: "air-base" } }, [
    _c(
      "section",
      {
        staticClass: "langing-gradient-bg relative overflow-hidden",
        staticStyle: { "min-height": "600px" },
        attrs: { id: "ac-header", "aria-label": "hero section" }
      },
      [
        _c("div", { staticClass: "container z-2" }, [
          _c("div", { staticClass: "row pt-5" }, [
            _c(
              "div",
              {
                staticClass: "d-flex text-left w-100 mb-50",
                attrs: { id: "landing-hero" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column justify-content-center align-items-start",
                    attrs: { id: "landing-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "box-right w-100",
                        attrs: { "data-aos": "fade-left" }
                      },
                      [
                        _c("h1", { staticClass: "title-header" }, [
                          _vm._v(
                            " \n                        " +
                              _vm._s(_vm.$t("ac_cleaning.hero_section.title")) +
                              "\n                        "
                          ),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("ac_cleaning.hero_section.subtitle")
                              )
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("ac_cleaning.hero_section.description")
                              ) +
                              "\n                      "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex gap-2 mt-5",
                        attrs: { "data-aos": "fade-left", id: "ac-contact" }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white line-bg line-text",
                            attrs: {
                              id: "btn-line",
                              type: "button",
                              href: _vm.lineUrl,
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/img/acCleaning/ac-v2/line-messenger-logo.png",
                                alt: "line messager icon"
                              }
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "ac_cleaning.hero_section.line_consultation"
                                  )
                                ) +
                                "\n                      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white bg-secon text-white",
                            attrs: {
                              to: { name: "New Booking", query: { sid: 16 } },
                              type: "button"
                            }
                          },
                          [
                            _c("SVGIcon", {
                              attrs: {
                                icon: "ac-icon.svg",
                                folder: "acCleaning/ac-v2",
                                alt: "air icon booking"
                              }
                            }),
                            _vm._v(
                              "\n                          " +
                                _vm._s(
                                  _vm.$t("ac_cleaning.hero_section.book_now")
                                ) +
                                "\n                      "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("MobileFlameDisplay", {
                      attrs: {
                        presentation:
                          "/static/img/acCleaning/ac-video/ac-cleaning.mp4"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("SnowFlake", { attrs: { amount: 15 } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "container",
        attrs: {
          id: "ac-cleaning-info",
          "aria-label": "air conditioner cleaning information"
        }
      },
      [
        _c(
          "div",
          { staticClass: "row pt-5", attrs: { id: "ac-cleaning-services" } },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-center align-items-center text-center w-100 pt-5"
              },
              [
                _c(
                  "h3",
                  { staticClass: "title", attrs: { "data-aos": "fade-left" } },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("ac_cleaning.service_section.title"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", { attrs: { "data-aos": "fade-right" } }, [
                  _vm._v(_vm._s(_vm.$t("ac_cleaning.service_section.subtitle")))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container pt-5" },
              [
                _c("Carousel", {
                  attrs: {
                    id: "ac-service",
                    images: _vm.acService,
                    routeFile: _vm.routeFile
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row pt-5", attrs: { id: "ac-cleaning-air-type" } },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-center align-items-center text-center w-100 pt-5"
              },
              [
                _c(
                  "h3",
                  { staticClass: "title", attrs: { "data-aos": "fade-left" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("ac_cleaning.service_types_section.title"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c("p", { attrs: { "data-aos": "fade-right" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("ac_cleaning.service_types_section.subtitle"))
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container pt-5" }, [
              _c(
                "div",
                { staticClass: "row justify-content-center" },
                _vm._l(_vm.acAirType.infoType, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "d-flex px-4 mb-4",
                      attrs: {
                        "data-aos": "fade-up",
                        "data-aos-delay": index * 100,
                        "data-aos-easing": "ease-in-out"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "360px", width: "360px" } },
                        [
                          _c("SquareImage", {
                            attrs: {
                              imageName: item.img,
                              title: item.title
                                ? _vm.$t(
                                    "ac_cleaning.service_types_section.infoType." +
                                      index +
                                      ".title"
                                  )
                                : "",
                              text: item.text
                                ? _vm.$t(
                                    "ac_cleaning.service_types_section.infoType." +
                                      index +
                                      ".text"
                                  )
                                : "",
                              routeFile: _vm.routeFile
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "container pt-5" }, [
              _c(
                "div",
                { staticClass: "pt-5" },
                [
                  _c("h5", { attrs: { "data-aos": "fade-left" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ac_cleaning.service_types_section.type01.title")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("IconListStyle", {
                    attrs: {
                      dataList: _vm.acAirType.contentAirType,
                      svgIcon: "checkmark-square-01.svg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pt-5" }, [
                _c("h5", { attrs: { "data-aos": "fade-left" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ac_cleaning.service_types_section.priceRateWallType.title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "pl-20",
                    staticStyle: { "list-style-type": "decimal" }
                  },
                  _vm._l(_vm.acAirType.servicePrice, function(rate, index) {
                    return _c("li", { key: index, staticClass: "py-1" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "ac_cleaning.service_types_section.priceRateWallType.rate_list." +
                                index
                            )
                          ) +
                          "\n              "
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row justify-content-center pt-5" },
                _vm._l(_vm.acAirType.servicePriceImg, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "d-flex px-4 mb-4",
                      attrs: {
                        "data-aos": "fade-up",
                        "data-aos-delay": index * 100,
                        "data-aos-easing": "ease-in-out"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "360px", width: "360px" } },
                        [
                          _c("SquareImage", {
                            attrs: {
                              imageName: item.img,
                              title: item.title
                                ? _vm.$t(
                                    "ac_cleaning.service_types_section.servicePriceImg." +
                                      index +
                                      ".title"
                                  )
                                : "",
                              text: item.text
                                ? _vm.$t(
                                    "ac_cleaning.service_types_section.servicePriceImg." +
                                      index +
                                      ".text"
                                  )
                                : "",
                              routeFile: _vm.routeFile
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pt-5" },
                [
                  _c("h5", { attrs: { "data-aos": "fade-left" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("ac_cleaning.service_types_section.type02.title")
                      ) + " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("IconListStyle", {
                    attrs: {
                      dataList: _vm.acAirType.cassetteType,
                      svgIcon: "checkmark-square-01.svg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pt-5" }, [
                _c("h5", { attrs: { "data-aos": "fade-left" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "ac_cleaning.service_types_section.priceRateCassetteType.title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    staticStyle: { gap: "10%" },
                    attrs: { id: "cassette-type" }
                  },
                  [
                    _c("div", [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "ac_cleaning.service_types_section.priceRateCassetteType.size_list[0].btu_price"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "pl-20",
                          staticStyle: { "list-style-type": "decimal" }
                        },
                        _vm._l(_vm.acAirType.cassettePrice.smallBTC, function(
                          rate,
                          index
                        ) {
                          return _c("li", { key: index, staticClass: "py-1" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$t(
                                    "ac_cleaning.service_types_section.priceRateCassetteType.size_list[0].rate_list." +
                                      index
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "ac_cleaning.service_types_section.priceRateCassetteType.size_list[1].btu_price"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "pl-20",
                          staticStyle: { "list-style-type": "decimal" }
                        },
                        _vm._l(_vm.acAirType.cassettePrice.largeBTC, function(
                          rate,
                          index
                        ) {
                          return _c("li", { key: index, staticClass: "py-1" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "ac_cleaning.service_types_section.priceRateCassetteType.size_list[1].rate_list." +
                                      index
                                  )
                                ) +
                                "\n                  "
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("WhyBeNeat", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("WhyAirCleaning", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("ScopeOfWork", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("Covered", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("TransparentPricing", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("MoreThanCleaning", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("ApplyForWork", {
              staticClass: "py-4 w-100",
              attrs: {
                socialContacts: { professionalLineUrl: _vm.professionalLineUrl }
              }
            }),
            _vm._v(" "),
            _c("HelpCenter", {
              staticClass: "py-4 w-100",
              attrs: {
                socialContacts: {
                  lineUrl: _vm.lineUrl,
                  fbMessageUrl: _vm.fbMessageUrl
                }
              }
            }),
            _vm._v(" "),
            _c("Questions", { staticClass: "py-4 w-100" }),
            _vm._v(" "),
            _c("DownloadBeNeatApp", { staticClass: "py-4 w-100" })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass:
          "absolute d-flex justify-content-center align-items-center",
        attrs: { id: "floating-button-mobile", "aria-label": "contact buttons" }
      },
      [
        _c(
          "a",
          {
            staticClass:
              "px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white line-bg line-text",
            attrs: {
              id: "btn-line",
              type: "button",
              href: _vm.lineUrl,
              target: "_blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: "/static/img/acCleaning/ac-v2/line-messenger-logo.png",
                alt: "line messager icon"
              }
            }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("ac_cleaning.hero_section.line_consultation")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass:
              "px-77 py-16 d-flex gap-2 justify-content-center align-items-center rounded-full border-2-white bg-secon text-white",
            staticStyle: {
              "border-radius": "100px",
              border: "1px solid #FFF",
              background: "var(#31C1D7)",
              "box-shadow": "0px 0px 6px 0px #31C1D7"
            },
            attrs: {
              to: { name: "New Booking", params: { sid: 16 } },
              type: "button"
            }
          },
          [
            _c("SVGIcon", {
              attrs: {
                icon: "ac-icon.svg",
                folder: "acCleaning/ac-v2",
                alt: "air icon booking"
              }
            }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ac_cleaning.hero_section.book_now")) +
                "\n    "
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cf82e4a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf82e4a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/AcCleaningV2.vue
// module id = 1617
// module chunks = 0